import React from "react";
import NotesList from "../../Components/NotesItems/NotesList/NotesList";
import "./Notes.scss";
import { hasPermission } from "../../Services/permission";

const NOTES_SECTION = "Notes";
const NOTES_EDIT_KEY = ["notes_edit"];

const Notes = () => {

    const canEditNotes = hasPermission({ section: NOTES_SECTION, keys: NOTES_EDIT_KEY, });

  return <NotesList canEditNotes={canEditNotes}/>;
};

export default Notes;
